import { useLocation } from "react-router-dom";

// Custom hook to get query parameters
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

export default useQuery;
